import ApiService from '../apiservice'

export default class TipoAcaoService extends ApiService {

  constructor() {
    super('/tipoAcao');
  }

  cadastrarTipo(tipo) {
    return this.post('/',tipo);
  }

  listarTipoAcao(empresa) {
    return this.get(`?empresa=${empresa}`);
  }

  listarTipoAcao2(empresa) {
    return this.get(`/tipo-acao-2?empresa=${empresa}`);
  }

  consultarTipo(codigo) {
    return this.get(`/${codigo}`);
  }

  alterarTipo(tipo) {
    return this.put(`/${tipo.codigo}`, tipo);
  }

  excluirTipo(codigo) {
    return this.delete(`/${codigo}`);
  }
}